export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  bar: "main-nav",
  logo: "nav-logo",
  home: "nav-home",
  about: "nav-about",
  wines: "nav-wines",
  shop: "nav-shop",
  contact: "nav-contact",
  langToggle: "nav-lang-toggle",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  title: "hero-title",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const SECTIONS = {
  identity: "section-identity",
  heritage: "section-heritage",
  process: "section-process",
  spotlight: "section-spotlight",
  wines: "section-wines",
  shop: "section-shop",
  contact: "section-contact",
};

export const SHOP = {
  grid: "shop-grid",
  card: (slug) => `shop-card-${slug}`,
  add: (slug) => `shop-add-${slug}`,
  cart: "shop-cart",
  cartItem: (slug) => `cart-item-${slug}`,
  cartInc: (slug) => `cart-inc-${slug}`,
  cartDec: (slug) => `cart-dec-${slug}`,
  cartRemove: (slug) => `cart-remove-${slug}`,
  cartTotal: "cart-total",
  checkoutOpen: "checkout-open",
  checkoutForm: "checkout-form",
  field: (n) => `checkout-${n}`,
  submit: "checkout-submit",
  success: "checkout-success",
};

export const WINES = {
  card: (slug) => `wine-card-${slug}`,
  grid: "wines-grid",
};

export const CONTACT = {
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
};

export const FOOTER = {
  root: "footer",
  instagram: "footer-instagram",
  phone: "footer-phone",
  email: "footer-email",
};
